import { useRouterContext } from "@refinedev/core";
import { Col, Row, Spin } from "antd";

import { createDoc, getDocument, updateDoc } from "api/admin";
import { DocumentEditor } from "components/Panel/Admin/Documents/DocumentEditor";
import { useState, useEffect } from "react";
import classes from "../../../components/Panel/Admin/UserOverview/User.module.css";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

export const AdminDocsEditor = () => {
	const [loading, setLoading] = useState(false);
	const { useParams } = useRouterContext();
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();

	const [doc, setDoc] = useState<any>(null);

	useEffect(() => {
		(async () => {
			if (id) {
				setLoading(true);
				const doc = await getDocument(id);
				setLoading(false);
				setDoc(doc.data);
			}
		})();
	}, [id]);

	return (
		<Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 48, color: "white" }} spin />}>
			<Row>
				<Col
					md={{
						span: 3,
					}}
					lg={{
						span: 4,
					}}
				></Col>
				<Col
					md={{
						span: 15,
					}}
					lg={{
						span: 18,
					}}
					style={{ margin: "1rem" }}
				>
				</Col>
			</Row>
		</Spin>
	);
};
